import React, { memo } from "react";
import {
	Modal, Button
} from "react-bootstrap";

const TimeoutPopup = memo( function TimeoutPopup({
	isOpen, endCurrentSectionAndStartNext
}) {

	const toggle = () => {
		endCurrentSectionAndStartNext();
	};

	return (
    <Modal show={isOpen} size="sm" centered contentClassName="mock-container">
      <Modal.Body>
        <div className="d-flex gap-2 align-items-center mock-resource-text">
          Test stopped due to timeout.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          className="mock-test-modal-button"
          onClick={toggle}
        >
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

export default TimeoutPopup;